module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, "\u2013").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " kiv\xE1lasztva");
  },
  "finishRangeSelectionPrompt": "Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek befejez\xE9s\xE9hez",
  "maximumDate": "Utols\xF3 el\xE9rhet\u0151 d\xE1tum",
  "minimumDate": "Az els\u0151 el\xE9rhet\u0151 d\xE1tum",
  "next": "K\xF6vetkez\u0151",
  "previous": "El\u0151z\u0151",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Kijel\xF6lt d\xE1tum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Kijel\xF6lt tartom\xE1ny: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek ind\xEDt\xE1s\xE1hoz",
  "todayDate": function todayDate(args) {
    return "Ma, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Ma, ".concat(args.date, " kijel\xF6lve");
  }
};